import React, { useCallback, useEffect, useState } from 'react';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import LeaveMenuBarItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/LeaveMenuBarItem';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  onSubmit?: (data: any) => void;
  onClose?: () => void;
  value: {
    title: string;
    type?: 'type1' | 'type2' | 'type3' | 'type4' | 'type5' | 'type6'; // type1: 모션, type2: square, type3: round, type4: text, type5: underBar, type6: round white
    cateMenuList: { value: string | number; text: string; my?: boolean }[];
    selectedValue?: number | string | undefined;
    isIPhoneXApp: boolean;
  };
}

const FoldMenuModal = ({ onSubmit, onClose, value }: IProps) => {
  const { title, cateMenuList, selectedValue, type, isIPhoneXApp } = value;
  // 필터 모달 클래스 네임
  const [cName, setClassName] = useState('');

  // 필터 상태 리스트 존재 하면 클래스 추가
  useEffect(() => {
    setClassName(classNameBind([isIPhoneXApp ? 'is-old-app-iphonex' : '']));
  }, [isIPhoneXApp, setClassName]);

  const handleSubmit = useCallback(
    (newSelectedValue: string | number) => {
      if (typeof onSubmit === 'function') {
        onSubmit(newSelectedValue);
      }
    },
    [onSubmit]
  );

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.FoldMenuModal className={cName}>
      <ModalEdgeCloseBtn onClick={handleClose} />
      <div className="content">
        <div className="item-box">
          {cateMenuList?.map(v => (
            <LeaveMenuBarItem
              key={v.value}
              value={v.value}
              text={v.text}
              my={v.my}
              type={type}
              selectedValue={selectedValue}
              onClick={() => {
                handleSubmit(String(v.value));
              }}
            />
          ))}
        </div>
      </div>
    </S.FoldMenuModal>
  );
};

export default FoldMenuModal;
